import { render, staticRenderFns } from "./DynamicAudioPlayer.vue?vue&type=template&id=0b8a23f0"
import script from "./DynamicAudioPlayer.vue?vue&type=script&lang=ts"
export * from "./DynamicAudioPlayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports